<template>
  <div class="column is-12 title is-4 m-0">
    {{ title }}
    <button type="button" class="button is-primary is-small ml-2" @click="addElement()"><font-awesome-icon icon="plus" />Aggiungi</button>
  </div>

  <slot name="header"></slot>

  <div class="column is-12" v-for="(element, index) in elements" :key="index">
    <div class="box">
      <div class="columns is-multiline" v-disableAll="element.archived">
        <div class="column is-12-mobile is-2-tablet is-1-desktop" v-if="tag">
          <InputText :name="tag" v-model="element.number" />
        </div>

        <div class="column is-12-mobile is-3-tablet is-2-desktop">
          <div class="field">
            <label class="label">Data di installazione</label>
            <div class="control">
              <input class="input" type="date" placeholder="Data di installazione" v-model="element.date_install" />
            </div>
          </div>
        </div>

        <div class="column is-12-mobile is-6-tablet is-4-desktop" v-if="elements_linked">
          <InputSelect
            :name="title_linked"
            v-model="element.link"
            :options="elements_linked"
            label="number"
          />
        </div>

        <div class="column is-12-mobile is-3-tablet is-2-desktop">
          <InputSelect
            name="Codice"
            v-model="element.code"
            :options="codes"
          />
        </div>

        <div class="column is-12-mobile is-3-tablet is-2-desktop">
          <InputSelect
            name="Installatore"
            v-model="element.installer"
            :options="installers"
            :loading="waitInstallers"
          />
        </div>

        <div class="column is-12-mobile is-3-tablet is-2-desktop" v-show="element.archived">
          <div class="field">
            <label class="label">Data di dismissione</label>
            <div class="control">
              <input class="input" type="date" placeholder="Data di dismissione" v-model="element.date_dismission" id="date_dismission" />
            </div>
          </div>
        </div>

        <div class="column is-12-mobile is-2-tablet is-1-desktop">
          <label class="label">&nbsp;</label>
          <button class="button is-primary is-light" type="button" v-show="!element._showall" @click="element._showall = true">Mostra tutto</button>
          <button class="button is-primary is-light" type="button" v-show="element._showall" @click="element._showall = false">Nascondi</button>
        </div>

        <div class="column is-12" v-show="element._showall">
          <slot :element="element"></slot>

          <div class="buttons is-right">
            <button class="button is-small is-primary" type="button" @click="openTransfer(element)" :disabled="!element._id">
              Trasferisci
            </button>

            <button class="button is-small is-warning" type="button" @click="decommission(element, true)" v-show="!element.archived">
              Sostituisci
            </button>

            <button class="button is-small is-warning" type="button" @click="decommission(element, false)" v-show="!element.archived">
              Dismetti
            </button>

            <button class="button is-small is-success" type="button" @click="reactivate(element)" v-show="element.archived">
              Riattiva
            </button>

            <button class="button is-small is-danger" type="button" @click="removeElement(index)">
              <span class="icon"><font-awesome-icon icon="trash-can" /></span>
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from '../../utils'

export default {
  props: {
    elements: Array,

    title: String,
    tag: String,

    title_linked: String,
    elements_linked: Array,

    codes: Array
  },
  emits: ['update:elements', 'transfer'],

  data() {
    return {
      installers: [],
      waitInstallers: true
    }
  },

  watch: {
    elements: {
      handler() {
        this.$nextTick(() => {
          this.$forceUpdate()
        })
      },
      deep: true,
      immediate: true
    }
  },

  mounted() {
    const self = this

    utils.fetchClients(this.$http).then(function (clients) {
      self.installers = clients
        .filter(client => !!client.isInstaller)
        .map(client => utils.clientName(client))
      self.waitInstallers = false
    })
  },

  methods: {
    addElement(newElement = {}) {
      this.$emit('update:elements', [...this.elements, newElement])
    },

    removeElement(index) {
      this.$emit('update:elements', this.elements.toSpliced(index, 1))
    },

    decommission(element, replaced = false) {
      element.archived = true
      element.replaced = replaced
      element._showall = false

      if (replaced) {
        this.addElement({ number: element.number || '' })
      }
    },

    reactivate(element) {
      element.archived = false
      element.replaced = false
      element._showall = false
    },

    openTransfer(element) {
      this.$emit('transfer', element)
    }
  }
}
</script>